// Must be first — sets MapLibre worker URL before react-map-gl imports it
import "./setup-maplibre";
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { runStateMigrations } from "@/lib/stateMigrations";
import { loadRuntimeConfig } from "@/lib/runtimeConfig";

// Migrate any stored client state before React reads it.
runStateMigrations();
// Fetch /api/config once at boot; UI re-renders when it lands (fails open).
loadRuntimeConfig();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
